import { useEffect } from 'react'

interface SEOHeadProps {
  title: string
  description: string
  keywords?: string
  canonicalUrl?: string
  ogType?: string
  articleData?: {
    publishedTime?: string
    modifiedTime?: string
    author?: string
    tags?: string[]
  }
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  articleData,
}: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} | 快猫短视频`
    document.title = fullTitle

    const updateMeta = (name: string, content: string, attr: 'name' | 'property' = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    updateMeta('description', description, 'name')
    if (keywords) updateMeta('keywords', keywords, 'name')

    updateMeta('og:title', fullTitle, 'property')
    updateMeta('og:description', description, 'property')
    if (ogType) updateMeta('og:type', ogType, 'property')
    if (canonicalUrl) {
      updateMeta('og:url', canonicalUrl, 'property')
      let link = document.querySelector('link[rel="canonical"]')
      if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
      }
      link.setAttribute('href', canonicalUrl)
    }

    if (articleData) {
      updateMeta('article:published_time', articleData.publishedTime || '', 'property')
      updateMeta('article:author', articleData.author || '', 'property')
      if (articleData.tags) {
        articleData.tags.forEach((tag) => {
          let tagEl = document.querySelector(`meta[property="article:tag"][content="${tag}"]`)
          if (!tagEl) {
            tagEl = document.createElement('meta')
            tagEl.setAttribute('property', 'article:tag')
            tagEl.setAttribute('content', tag)
            document.head.appendChild(tagEl)
          }
        })
      }
    }
  }, [title, description, keywords, canonicalUrl, ogType, articleData])

  return null
}